import request from "../shared/http";
import appConfig from "../shared/js/app-config";

const sid = (serviceId) => serviceId || appConfig.getServiceId();
const unwrap = (res) => res?.data ?? res;

class AppointmentService {
  listTypes(serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/appointment-types`).then(unwrap);
  }

  createType(payload, serviceId) {
    return request.post(`/vertical/${sid(serviceId)}/appointment-types`, payload).then(unwrap);
  }

  updateType(id, payload, serviceId) {
    return request.put(`/vertical/${sid(serviceId)}/appointment-types/${id}`, payload).then(unwrap);
  }

  listResources(serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/appointment-resources`).then(unwrap);
  }

  createResource(payload, serviceId) {
    return request.post(`/vertical/${sid(serviceId)}/appointment-resources`, payload).then(unwrap);
  }

  updateResource(id, payload, serviceId) {
    return request.put(`/vertical/${sid(serviceId)}/appointment-resources/${id}`, payload).then(unwrap);
  }

  listBookings(serviceId) {
    return request.get(`/vertical/${sid(serviceId)}/appointment-bookings`).then(unwrap);
  }

  listStaff(serviceId) {
    return request.get(`/routing/staff/${sid(serviceId)}`).then(unwrap);
  }

  cancelBooking(id, payload = {}, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/appointment-bookings/${id}/cancel`, payload)
      .then(unwrap);
  }

  rescheduleBooking(id, payload = {}, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/appointment-bookings/${id}/reschedule`, payload)
      .then(unwrap);
  }

  availability(payload, serviceId) {
    return request
      .post(`/vertical/${sid(serviceId)}/appointment/actions/availability`, payload)
      .then(unwrap);
  }

  actionRegistry() {
    return request.get("/vertical/actions-registry").then(unwrap);
  }
}

export default new AppointmentService();
